module.exports = __webpack_public_path__ + "img/AMP4200_S_SW_001_2048x2048.3a98aa5a.png";